import { useQuery } from "@tanstack/react-query";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import { DashboardResponse } from "app/data/static-load/model";

export const useDashboard = (
  division: string,
  weekStartDate: string,
  enabled = true,
  region?: string
) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [QUERY_KEYS.GET_DASHBOARD, division, weekStartDate, region ?? ""],
    queryFn: async () => {
      const params: Record<string, string> = { division, weekStartDate };
      if (region) {
        params.region = region;
      }

      const response = await apiQueryAdapter.query<DashboardResponse>(
        "/manifest-management/dashboard",
        "GET",
        { params }
      );

      return response.data;
    },
    enabled: enabled && !!division && !!weekStartDate,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return { data, isLoading, refetch };
};